import template from 'lodash/template';
import omit from 'lodash/fp/omit';
import { createSelector } from 'reselect';
import pathRegex, { globalParentPath } from 'config/pathRegex';
import {
  CONTENT_ARCHIVE,
  CONTENT_ITEM_SINGLE,
  CATEGORY_ARCHIVE,
  TERM_ARCHIVE,
  PAGE,
} from 'config/types/path';

const createGetSlugs = (stateKey) => (state) =>
  Object
    .keys(state[stateKey])
    .map((id) => state[stateKey][id].slug);

export const getLocalPathMap = createSelector(
  [
    createGetSlugs('contentType'),
  ],
  (contentTypes) => {
    // Exclude some content types from having archive routes.
    const archiveContentTypes = contentTypes;

    const compileItemPath = template(pathRegex[CONTENT_ITEM_SINGLE]);
    const compileArchivePath = template(pathRegex[CONTENT_ARCHIVE]);
    const compileCategoryPath = template(pathRegex[CATEGORY_ARCHIVE]);
    const compileTermPath = template(pathRegex[TERM_ARCHIVE]);
    const contentTypeList = contentTypes.join('|');
    const compiledMap = {
      ...pathRegex,
      [CONTENT_ITEM_SINGLE]: compileItemPath({
        contentTypes: contentTypeList,
      }),
      [CONTENT_ARCHIVE]: compileArchivePath({
        contentTypes: archiveContentTypes.join('|'),
      }),
      [CATEGORY_ARCHIVE]: compileCategoryPath({
        contentTypes: contentTypeList,
      }),
      [TERM_ARCHIVE]: compileTermPath({
        contentTypes: contentTypeList,
      }),
    };

    return compiledMap;
  },
);

/**
 * @return {object} A map of path types to path regex
 */
export default createSelector(
  [getLocalPathMap],
  (localPathMap) => {
    if (globalParentPath) {
      // Don't compile parent route
      const pathsWithParent = omit([globalParentPath], localPathMap);
      const compiledMapWithParent = Object.keys(pathsWithParent)
        .reduce((acc, pathName) => ({
          ...acc,
          [pathName]: `${localPathMap[globalParentPath]}${localPathMap[pathName]}`,
        }), {});

      return {
        ...localPathMap,
        ...compiledMapWithParent,
      };
    }

    return localPathMap;
  },
);
